import { PostTikTok, PostTikTokInput, PostTikTokPrivacy, ThirdPartyProfileSearchType } from '../../../models/graphql';
import { SelectedSocialProfileValue } from '../../../components/socialProfiles/SocialProfileSelectorList/SocialProfileSelectorList.view';
import { SocialProfileWithBoards } from '../../../hooks/useCategoriesProfilesWithBoards';
import { TikTokProfileValues } from '../../../components/socialProfiles/SocialProfileListItem/SocialProfileListItem.view';

export type SocialProfileWithMentionType = SocialProfileWithBoards & {
  mentionType: ThirdPartyProfileSearchType | null;
};

export type SocialProfileWithBoardsAndMentionType = SocialProfileWithMentionType & {
  selectedPnBoardId?: string;
};

export const mapSelectedProfilesValues = (
  selectedProfiles: SelectedSocialProfileValue[],
  profiles: SocialProfileWithMentionType[]
): SocialProfileWithBoardsAndMentionType[] => {
  return selectedProfiles.flatMap(profile => {
    const fullProfile = profiles.find(p => p.id === profile.profileId);
    if (!fullProfile) return [];
    return {
      ...fullProfile,
      ...(fullProfile.__typename === 'PinterestSocialProfile'
        ? {
            selectedPnBoardId: fullProfile.boards.find(board => board.externalId === profile.pnBoardId)?.externalId
          }
        : {})
    };
  });
};

export const mapPostTikTokToTikTokProfileValues = (value: PostTikTok): TikTokProfileValues => {
  const { privacy } = value;
  let allowedActions: TikTokProfileValues['allowedActions'] = [];
  let promotion: TikTokProfileValues['promotion'] = [];
  if (privacy !== PostTikTokPrivacy.SELF_ONLY) {
    if (!value.disableComment) {
      allowedActions = Array.from(
        new Set<TikTokProfileValues['allowedActions'][number]>([...allowedActions, 'comment'])
      );
    }
    if (!value.disableDuet) {
      allowedActions = Array.from(new Set<TikTokProfileValues['allowedActions'][number]>([...allowedActions, 'duet']));
    }
    if (!value.disableStitch) {
      allowedActions = Array.from(
        new Set<TikTokProfileValues['allowedActions'][number]>([...allowedActions, 'stitch'])
      );
    }
    if (value.brandOther) {
      promotion = Array.from(new Set<TikTokProfileValues['promotion'][number]>([...promotion, 'other']));
    }
    if (value.brandSelf) {
      promotion = Array.from(new Set<TikTokProfileValues['promotion'][number]>([...promotion, 'self']));
    }
  }
  return {
    privacyTarget: privacy || null,
    allowedActions,
    promotion
  };
};

export const mapTikTokProfileValuesToPostTikTokInput = (value: TikTokProfileValues): PostTikTokInput | null => {
  const { privacyTarget, allowedActions, promotion } = value;
  if (!privacyTarget) return null;
  return {
    privacy: privacyTarget,
    disableComment: !allowedActions.includes('comment'),
    disableDuet: !allowedActions.includes('duet'),
    disableStitch: !allowedActions.includes('stitch'),
    brandSelf: promotion.includes('self'),
    brandOther: promotion.includes('other'),
    autoAddMusic: true
  };
};

export const mapSocialProfileWithBoardsAndMentionToSelectedValue = (
  profiles: SocialProfileWithBoardsAndMentionType[]
): SelectedSocialProfileValue[] =>
  profiles.map(profile => ({
    __typename: profile.__typename,
    profileId: profile.id,
    ...(profile.selectedPnBoardId ? { pnBoardId: profile.selectedPnBoardId } : {})
    // ...(profile.tikTok ? { tikTok: mapPostTikTokToTikTokProfileValues(profile.tikTok) } : {})
  }));
